// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"restaurantManagement_wrapper__2g6US","left":"restaurantManagement_left__3b8sH","right":"restaurantManagement_right__2mTdj"};